<div class="flex flex--column border rounded-large white-bg surface-primary ms-medium-b overflow-hidden">
  <div class="ps-medium">
    <h3 data-testid="greeting-title" data-hj-suppress data-dd-privacy="hidden">
      {{ 'loginPromotion.greeting.title.inPaxDetails' | finLocalization: { name: firstName() } }}
    </h3>
    <p data-testid="greeting-description" class="pr-xxsmall-t">
      {{ textKey() | finLocalization }}
    </p>
  </div>
</div>
